import fetchService from '../../services/api/fetch-facilitators'
import { useQuery } from 'react-query'

const useItems = () => {
    const { data } = useQuery('facilitators', fetchService, { staleTime: 86400000, cacheTime: 86400000 })
    return [
        data
    ]
}

export default useItems